function CreatorCLogo(props) {
  return (
    <svg
      className={props.className}
      width="135"
      height="40"
      viewBox="0 0 135 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4498_4329)">
        <path
          d="M20.6236 0C22.3707 5.07953 24.8155 11.7496 26.4908 16.6239C26.6883 17.2011 26.6447 17.4859 25.8751 17.4987C23.3815 17.5423 22.617 15.7799 21.9397 13.3607C21.7088 12.5372 21.4266 11.7291 21.188 10.9082C21.1213 10.6798 21.129 10.4669 20.8468 10.4489C20.5262 10.431 20.5082 10.6798 20.4466 10.8928C19.8438 12.9708 19.1947 15.0385 18.6508 17.1319C18.4276 17.9836 18.0351 18.3068 17.1475 18.2966C14.9695 18.2658 12.7863 18.3273 10.6134 18.3504C10.3876 18.3504 10.0849 18.2581 10.0054 18.5403C9.95407 18.7301 10.3107 18.8635 10.4877 18.9892C12.3322 20.3027 14.1716 21.6265 16.0495 22.8912C16.7139 23.3376 16.5805 23.8558 16.4112 24.4305C15.8007 26.4982 15.0721 28.4454 14.5693 30.6311C14.5282 30.7568 14.5359 30.8928 14.5923 31.0108C14.6462 31.0852 14.7463 31.1057 14.8232 31.057C16.8576 29.805 18.3584 28.5557 20.0233 27.1652C21.0777 26.2853 21.0649 26.3161 22.0757 27.3268C24.8104 30.0513 27.522 32.7989 30.3517 35.4284C30.952 35.9877 30.8648 36.0313 31.0649 37.1524C30.2619 36.6137 30.3645 36.724 29.718 36.3161C27.0577 34.6357 24.4666 32.8553 21.9448 30.9723C21.3933 30.5593 20.9187 30.5977 20.4389 31.0185C18.1301 33.0528 15.5133 34.6639 13.1403 36.6162C11.6472 37.8553 10.0669 38.9841 8.41481 40C8.6534 39.0534 8.81245 38.294 9.03565 37.5526C10.244 33.5582 11.4471 29.5639 12.7016 25.5849C12.9171 24.9051 12.7222 24.5998 12.1885 24.215C8.22497 21.3212 4.23575 18.471 0.174691 15.7055C0.072074 15.6465 -0.00488858 15.549 0.000242259 15.5105C0.072074 15.1565 0.32092 15.3361 0.47741 15.3335C5.3517 15.236 10.244 15.1385 15.1285 15.077C15.734 15.077 16.0085 14.8615 16.1547 14.2766L20.6236 0Z"
          fill="#439A9C"
        />
        <path
          d="M47.2031 14.923V10.9055H52.1903V14.923H47.2031ZM52.121 17.8321V35.1462H47.2724V17.8321H52.121Z"
          fill="black"
        />
        <path
          d="M67.8816 17.7271V21.7805H62.6867V29.2587C62.6867 30.7825 63.482 31.0955 64.5569 31.0955H68.7462V35.1463H63.8719C59.0566 35.1463 57.7765 32.7913 57.7765 28.1504V21.7805H54.2695V17.7271H55.3085C57.1043 17.7271 58.9001 14.5075 58.9001 11.8062H63.8539C63.818 12.1858 63.7847 12.6014 63.7154 13.017C63.5384 13.9098 63.21 14.7641 62.7457 15.5465C62.1813 16.27 61.4861 16.8805 60.6933 17.3423C60.0366 17.6527 59.1002 17.7913 58.4076 17.8965V17.9657C59.1849 17.8298 59.9725 17.7502 60.7626 17.722L67.8816 17.7271Z"
          fill="black"
        />
        <path
          d="M83.5693 21.8496H78.0973C76.1578 21.8496 75.7884 22.2652 75.7884 24.6536V35.1462H70.832V22.7808C70.832 19.3868 72.2533 17.8296 75.7859 17.8296H83.577L83.5693 21.8496Z"
          fill="black"
        />
        <path
          d="M85.6484 14.923V10.9055H90.6356V14.923H85.6484ZM90.5663 17.8321V35.1462H85.7126V17.8321H90.5663Z"
          fill="black"
        />
        <path
          d="M104.661 17.5552C109.437 17.5552 111.446 21.3648 111.446 27.2499V35.1462H106.531V27.2165C106.531 24.1688 104.971 22.5064 102.824 22.5064C100.677 22.5064 97.6648 23.684 97.6648 28.6634V35.1462H92.7109V17.8322H97.6648V21.9523C97.6442 22.745 97.5493 23.5326 97.3877 24.3074H97.457C97.5955 23.6147 97.7674 22.645 98.0804 22.0575C99.4657 18.9046 102.306 17.5552 104.661 17.5552Z"
          fill="black"
        />
        <path
          d="M134.065 27.4576H118.134C118.321 28.7019 119.009 29.8153 120.04 30.5361C121.01 31.2622 122.534 31.6085 123.919 31.6085H124.193C125.543 31.6085 126.651 31.47 127.528 31.0544C128.488 30.6028 129.232 29.7973 129.604 28.8045L134.142 29.0456C133.691 31.5751 132.203 33.1323 130.402 34.0687C128.601 35.0051 126.453 35.3514 124.065 35.3514C118.385 35.3514 113.547 32.4782 113.547 26.4879C113.547 20.4977 118.396 17.6218 124.065 17.6218C129.735 17.6218 134.142 20.531 134.142 26.4879C134.134 26.8112 134.109 27.137 134.065 27.4576ZM123.988 21.157C122.705 21.157 120.974 21.5726 119.866 22.5423C118.757 23.512 118.134 25.1077 118.134 27.042V27.4576C118.17 26.2134 118.516 25.7619 119.034 25.3129C119.553 24.864 120.42 24.687 121.148 24.687H129.563C129.181 23.4428 128.662 22.6347 127.798 22.0574C126.933 21.4802 125.581 21.157 124.206 21.157H123.988Z"
          fill="black"
        />
        <path
          d="M39.5346 8.15796H45.6916L32.336 35.0949L22.8594 19.0199H28.7804L32.336 24.4663L39.5346 8.15796Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_4498_4329">
          <rect width="134.141" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function SmileyWink(props) {
  return (
    <svg
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM7.5 10.125C7.5 9.9025 7.56598 9.68499 7.6896 9.49998C7.81322 9.31498 7.98892 9.17078 8.19449 9.08564C8.40005 9.00049 8.62625 8.97821 8.84448 9.02162C9.06271 9.06502 9.26317 9.17217 9.4205 9.3295C9.57783 9.48684 9.68498 9.68729 9.72839 9.90552C9.7718 10.1238 9.74952 10.35 9.66437 10.5555C9.57922 10.7611 9.43503 10.9368 9.25002 11.0604C9.06502 11.184 8.84751 11.25 8.625 11.25C8.32664 11.25 8.04049 11.1315 7.82951 10.9205C7.61853 10.7095 7.5 10.4234 7.5 10.125ZM17.25 10.125C17.25 10.3239 17.171 10.5147 17.0303 10.6553C16.8897 10.796 16.6989 10.875 16.5 10.875H14.25C14.0511 10.875 13.8603 10.796 13.7197 10.6553C13.579 10.5147 13.5 10.3239 13.5 10.125C13.5 9.92609 13.579 9.73532 13.7197 9.59467C13.8603 9.45402 14.0511 9.375 14.25 9.375H16.5C16.6989 9.375 16.8897 9.45402 17.0303 9.59467C17.171 9.73532 17.25 9.92609 17.25 10.125ZM16.3988 14.625C15.4341 16.2928 13.8309 17.25 12 17.25C10.1691 17.25 8.56594 16.2937 7.60032 14.625C7.55107 14.5397 7.51911 14.4455 7.50626 14.3478C7.49342 14.2502 7.49993 14.1509 7.52544 14.0558C7.55095 13.9606 7.59495 13.8714 7.65493 13.7933C7.7149 13.7151 7.78969 13.6496 7.875 13.6003C7.96032 13.5511 8.0545 13.5191 8.15217 13.5063C8.24984 13.4934 8.34909 13.4999 8.44424 13.5254C8.53939 13.5509 8.62858 13.5949 8.70673 13.6549C8.78488 13.7149 8.85045 13.7897 8.89969 13.875C9.59907 15.0853 10.6997 15.75 12 15.75C13.3003 15.75 14.4009 15.0844 15.1013 13.875C15.1481 13.7854 15.2127 13.7062 15.291 13.6421C15.3693 13.5781 15.4597 13.5305 15.5569 13.5023C15.654 13.4742 15.7558 13.4659 15.8563 13.4781C15.9567 13.4903 16.0536 13.5227 16.1412 13.5733C16.2287 13.6239 16.3052 13.6917 16.3658 13.7727C16.4265 13.8536 16.4702 13.946 16.4943 14.0442C16.5183 14.1425 16.5223 14.2446 16.5059 14.3444C16.4895 14.4442 16.453 14.5396 16.3988 14.625Z"
        fill={props.fill ?? "white"}
      />
    </svg>
  );
}

function RocketLaunchIcon(props) {
  return (
    <svg
      className={props.className}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4498_4362)">
        <path
          d="M36.3134 11.6323C36.3692 11.0856 36.2231 10.5373 35.9025 10.091C35.5819 9.64465 35.109 9.33107 34.5731 9.20942C32.8444 8.81912 28.3567 8.24721 24.0475 11.3412L23.2789 11.9007L15.1843 10.5735C14.8918 10.5239 14.5925 10.5329 14.3035 10.6C14.0146 10.6671 13.7419 10.791 13.5013 10.9645L7.9606 14.9467C7.62086 15.1906 7.3558 15.5243 7.19518 15.9104C7.03455 16.2965 6.98471 16.7198 7.05125 17.1326C7.11779 17.5455 7.29808 17.9317 7.57188 18.2478C7.84568 18.5639 8.20216 18.7974 8.6013 18.9222L13.8177 20.5427L18.9469 27.6837L18.8164 33.1472C18.8067 33.5652 18.9141 33.9776 19.1265 34.3378C19.3389 34.698 19.6479 34.9916 20.0184 35.1854C20.2341 35.299 20.4667 35.3771 20.7072 35.4166C20.9985 35.4649 21.2963 35.4551 21.5838 35.3878C21.8712 35.3204 22.1424 35.1969 22.3819 35.0243L27.9249 31.0452C28.1661 30.8726 28.3706 30.6538 28.5265 30.4014C28.6824 30.1491 28.7865 29.8682 28.8328 29.5753L30.16 21.4807L30.9305 20.9273C35.2399 17.8319 36.131 13.3965 36.3134 11.6323ZM14.8202 12.7939L20.6945 13.757L14.3096 18.3418L9.27071 16.7775L14.8202 12.7939ZM25.3613 13.1755C26.604 12.277 28.0242 11.6541 29.5269 11.3483C31.0296 11.0425 32.5803 11.0609 34.0754 11.4022C33.9249 12.9293 33.4492 14.4066 32.6804 15.7346C31.9116 17.0627 30.8674 18.2108 29.6181 19.1018L20.3373 25.7655L16.0817 19.8408L25.3613 13.1755ZM26.6125 29.2112L21.0667 33.1983L21.1921 27.9221L27.5756 23.337L26.6125 29.2112ZM16.105 28.8422C15.2562 30.1081 12.6444 32.9575 6.77568 31.9953C6.48124 31.947 6.21804 31.7837 6.04398 31.5414C5.86991 31.2991 5.79925 30.9975 5.84752 30.7031C6.80972 24.8344 10.3439 23.2692 11.8148 22.8677C11.9574 22.8289 12.1062 22.8186 12.2528 22.8374C12.3994 22.8562 12.5408 22.9036 12.669 22.977C12.7972 23.0505 12.9098 23.1484 13.0001 23.2653C13.0905 23.3822 13.1569 23.5158 13.1957 23.6584C13.2344 23.801 13.2447 23.9498 13.226 24.0964C13.2072 24.2429 13.1598 24.3844 13.0863 24.5126C13.0129 24.6408 12.9149 24.7533 12.798 24.8437C12.6811 24.9341 12.5476 25.0005 12.405 25.0393C11.446 25.2996 9.26228 26.2853 8.31127 29.9129C12.0526 30.17 13.6868 28.4158 14.2369 27.5897C14.3192 27.467 14.4248 27.3616 14.5478 27.2797C14.6708 27.1978 14.8087 27.1409 14.9536 27.1122C15.0986 27.0836 15.2478 27.0838 15.3926 27.1128C15.5375 27.1419 15.6753 27.1991 15.798 27.2814C15.9208 27.3636 16.0261 27.4693 16.108 27.5922C16.19 27.7152 16.2469 27.8531 16.2755 27.9981C16.3041 28.143 16.3039 28.2922 16.2749 28.4371C16.2459 28.582 16.1886 28.7197 16.1064 28.8425L16.105 28.8422Z"
          fill={props.fill ?? "#549A9C"}
        />
      </g>
      <defs>
        <clipPath id="clip0_4498_4362">
          <rect
            width="36"
            height="36"
            fill="white"
            transform="translate(6.32422) rotate(9.3111)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function SparklesIcon(props) {
  return (
    <svg
      className={props.className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.023 12.0994L14.1874 10.3125L12.4062 5.47312C12.3007 5.18656 12.1098 4.93924 11.8594 4.76455C11.6089 4.58985 11.3109 4.49619 11.0055 4.49619C10.7002 4.49619 10.4022 4.58985 10.1517 4.76455C9.90124 4.93924 9.71039 5.18656 9.60491 5.47312L7.81241 10.3125L2.97303 12.0938C2.68646 12.1992 2.43915 12.3901 2.26445 12.6405C2.08976 12.891 1.99609 13.189 1.99609 13.4944C1.99609 13.7997 2.08976 14.0978 2.26445 14.3482C2.43915 14.5987 2.68646 14.7895 2.97303 14.895L7.81241 16.6875L9.59366 21.5269C9.69914 21.8134 9.88999 22.0608 10.1404 22.2355C10.3909 22.4101 10.6889 22.5038 10.9943 22.5038C11.2996 22.5038 11.5977 22.4101 11.8481 22.2355C12.0986 22.0608 12.2894 21.8134 12.3949 21.5269L14.1874 16.6875L19.0268 14.9062C19.3133 14.8008 19.5607 14.6099 19.7354 14.3595C19.91 14.109 20.0037 13.811 20.0037 13.5056C20.0037 13.2003 19.91 12.9022 19.7354 12.6518C19.5607 12.4013 19.3133 12.2105 19.0268 12.105L19.023 12.0994ZM13.3437 15.3956C13.2419 15.4331 13.1494 15.4923 13.0727 15.569C12.996 15.6457 12.9368 15.7382 12.8993 15.84L10.9999 20.9859L9.10428 15.8438C9.06682 15.7409 9.00729 15.6474 8.92988 15.57C8.85246 15.4926 8.75903 15.4331 8.65616 15.3956L3.51397 13.5L8.65616 11.6044C8.75903 11.5669 8.85246 11.5074 8.92988 11.43C9.00729 11.3526 9.06682 11.2591 9.10428 11.1562L10.9999 6.01406L12.8955 11.1562C12.9331 11.2581 12.9922 11.3505 13.0689 11.4272C13.1456 11.5039 13.2381 11.5631 13.3399 11.6006L18.4858 13.5L13.3437 15.3956ZM13.9999 3.75C13.9999 3.55109 14.0789 3.36032 14.2196 3.21967C14.3602 3.07902 14.551 3 14.7499 3H16.2499V1.5C16.2499 1.30109 16.3289 1.11032 16.4696 0.96967C16.6102 0.829018 16.801 0.75 16.9999 0.75C17.1988 0.75 17.3896 0.829018 17.5302 0.96967C17.6709 1.11032 17.7499 1.30109 17.7499 1.5V3H19.2499C19.4488 3 19.6396 3.07902 19.7802 3.21967C19.9209 3.36032 19.9999 3.55109 19.9999 3.75C19.9999 3.94891 19.9209 4.13968 19.7802 4.28033C19.6396 4.42098 19.4488 4.5 19.2499 4.5H17.7499V6C17.7499 6.19891 17.6709 6.38968 17.5302 6.53033C17.3896 6.67098 17.1988 6.75 16.9999 6.75C16.801 6.75 16.6102 6.67098 16.4696 6.53033C16.3289 6.38968 16.2499 6.19891 16.2499 6V4.5H14.7499C14.551 4.5 14.3602 4.42098 14.2196 4.28033C14.0789 4.13968 13.9999 3.94891 13.9999 3.75ZM23.7499 8.25C23.7499 8.44891 23.6709 8.63968 23.5302 8.78033C23.3896 8.92098 23.1988 9 22.9999 9H22.2499V9.75C22.2499 9.94891 22.1709 10.1397 22.0302 10.2803C21.8896 10.421 21.6988 10.5 21.4999 10.5C21.301 10.5 21.1102 10.421 20.9696 10.2803C20.8289 10.1397 20.7499 9.94891 20.7499 9.75V9H19.9999C19.801 9 19.6102 8.92098 19.4696 8.78033C19.3289 8.63968 19.2499 8.44891 19.2499 8.25C19.2499 8.05109 19.3289 7.86032 19.4696 7.71967C19.6102 7.57902 19.801 7.5 19.9999 7.5H20.7499V6.75C20.7499 6.55109 20.8289 6.36032 20.9696 6.21967C21.1102 6.07902 21.301 6 21.4999 6C21.6988 6 21.8896 6.07902 22.0302 6.21967C22.1709 6.36032 22.2499 6.55109 22.2499 6.75V7.5H22.9999C23.1988 7.5 23.3896 7.57902 23.5302 7.71967C23.6709 7.86032 23.7499 8.05109 23.7499 8.25Z"
        fill={props.fill ?? "white"}
      />
    </svg>
  );
}

function TickIcon(props) {
  return (
    <svg
      className={props.className}
      width="38"
      height="45"
      viewBox="0 0 38 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.4728 0H37.6167L15.613 44.4459L0 17.9223H9.75497L15.613 26.9088L27.4728 0Z"
        fill="url(#paint0_linear_4498_4388)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4498_4388"
          x1="35.4537"
          y1="4.40194e-06"
          x2="1.35821"
          y2="3.48821"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#549A9C" />
          <stop offset="1" stopColor="#65ACAE" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function FlyingMoney(props) {
  return (
    <svg
      className={props.className}
      width="128"
      height="129"
      viewBox="0 0 128 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66.0021 92.3379L32.6884 59.1873C30.2613 56.7602 28.9219 53.5224 28.9219 50.0756C28.9219 46.6415 30.2512 43.4163 32.6633 40.9867C32.1043 37.1017 33.3179 33.008 36.2988 30.0246C36.3038 30.0196 36.3089 30.0144 36.3139 30.0069C35.7751 26.1347 36.9887 22.0635 39.9596 19.0926C40.9666 18.0856 42.5982 18.088 43.6053 19.09L66.8639 42.2933C67.6193 43.0511 90.4402 64.3585 90.0021 65.3379C89.559 66.3198 89.0796 69.4133 88.0021 69.3379C82.7501 69.0206 91.6577 78.6848 88.0021 82.3379C84.3463 85.9885 79.6697 79.1261 80.0021 84.3379C80.0676 85.4104 77.984 89.8972 77.0021 90.3379C76.0538 90.7696 66.7748 93.1146 66.0021 92.3379Z"
        fill="url(#paint0_linear_4498_4417)"
      />
      <path
        d="M78.2642 99.4204C74.815 99.4204 71.5772 98.0809 69.145 95.6489L60.4891 87.0408C59.7288 86.283 59.5174 85.1349 59.9555 84.1556C60.3986 83.1762 61.3956 82.5996 62.4681 82.64C67.6345 82.9773 72.7656 81.0639 76.4162 77.4106C80.072 73.7574 81.9803 68.6742 81.6479 63.4626C81.5825 62.3901 82.1816 61.3904 83.1586 60.9499C84.1405 60.5042 85.2469 59.5801 86.0021 60.3379L109.247 84.7348C110.254 85.7418 110.254 87.3734 109.247 88.3779C106.281 91.3463 102.243 92.5749 98.3302 92.0235C98.3252 92.0285 98.3201 92.0337 98.3151 92.0386C95.3341 95.0171 91.2706 96.2383 87.353 95.6767C84.9261 98.0911 81.7035 99.4204 78.2642 99.4204Z"
        fill="url(#paint1_linear_4498_4417)"
      />
      <g filter="url(#filter0_bi_4498_4417)">
        <path
          d="M47.2857 81.0567C38.2022 71.9732 38.2949 57.2549 47.2857 48.2785C56.1983 39.3563 70.9218 39.1332 80.0613 48.2785C90.2494 58.4668 87.9004 73.226 80.0613 81.0567C71.1765 89.9416 56.4682 90.2335 47.2857 81.0567Z"
          fill="#BCE4F1"
          fillOpacity="0.5"
        />
      </g>
      <path
        d="M22.7553 105.584C21.7482 104.577 21.7482 102.945 22.7553 101.938L38.5679 86.1254C39.5749 85.1184 41.2065 85.1184 42.2135 86.1254C43.2205 87.1324 43.2205 88.764 42.2135 89.771L26.4009 105.584C25.3937 106.591 23.7623 106.591 22.7553 105.584Z"
        fill="url(#paint2_linear_4498_4417)"
      />
      <path
        d="M38.224 105.583C37.217 104.576 37.217 102.944 38.224 101.937L48.8803 91.2807C49.8873 90.2736 51.519 90.2736 52.526 91.2807C53.533 92.2877 53.533 93.9193 52.526 94.9263L41.8697 105.583C40.8625 106.59 39.231 106.59 38.224 105.583Z"
        fill="url(#paint3_linear_4498_4417)"
      />
      <path
        d="M22.7553 90.1138C21.7482 89.1068 21.7482 87.4752 22.7553 86.4682L33.4116 75.8119C34.4186 74.8049 36.0502 74.8049 37.0572 75.8119C38.0643 76.8189 38.0643 78.4505 37.0572 79.4576L26.4009 90.1138C25.3937 91.1209 23.7623 91.1209 22.7553 90.1138Z"
        fill="url(#paint4_linear_4498_4417)"
      />
      <path
        d="M74.1803 54.1527C73.3608 53.3332 72.0329 53.3332 71.2134 54.1527L69.4295 55.9377C67.0941 54.8366 64.2379 55.1944 62.3125 57.1197C61.1241 58.3081 60.4684 59.89 60.4684 61.5721C60.4684 63.2524 61.1241 64.8341 62.3125 66.0225C63.1321 66.8401 63.1321 68.1719 62.3125 68.9895C61.493 69.809 60.1651 69.809 59.3456 68.9895C58.948 68.5919 58.7308 68.0654 58.7308 67.506C58.7308 66.3463 57.7924 65.4079 56.6326 65.4079C55.4729 65.4079 54.5345 66.3463 54.5345 67.506C54.5345 68.4581 54.7662 69.3681 55.1648 70.2033L53.4115 71.9565C52.592 72.7761 52.592 74.1039 53.4115 74.9235C54.2311 75.743 55.5588 75.7432 56.3785 74.9235L58.1621 73.1399C60.8771 74.4197 63.5718 73.6668 65.2792 71.9567C67.529 69.7069 67.6143 66.2164 65.7405 63.751C65.6381 63.498 65.4844 63.261 65.2792 63.056C64.4609 62.2377 64.4567 60.9115 65.2792 60.089C66.0987 59.2735 67.4266 59.2714 68.2461 60.0911C68.6437 60.4845 68.8609 61.0111 68.8609 61.5726C68.8609 62.7323 69.7993 63.6707 70.9591 63.6707C72.1188 63.6707 73.0572 62.7323 73.0572 61.5726C73.0572 60.6187 72.8257 59.7083 72.4276 58.8738L74.18 57.1201C74.9998 56.3 74.9999 54.9703 74.1803 54.1527Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_bi_4498_4417"
          x="36.5078"
          y="37.5029"
          width="54.3438"
          height="54.3271"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_4498_4417"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_4498_4417"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.2" dy="0.1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_4498_4417"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4498_4417"
          x1="105.34"
          y1="18.3379"
          x2="32.1496"
          y2="27.185"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7EE9EC" />
          <stop offset="1" stopColor="#6BBEC0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4498_4417"
          x1="105.34"
          y1="18.3379"
          x2="32.1496"
          y2="27.185"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7EE9EC" />
          <stop offset="1" stopColor="#6BBEC0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4498_4417"
          x1="41.7631"
          y1="85.3701"
          x2="22.8348"
          y2="87.6582"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7EE9EC" />
          <stop offset="1" stopColor="#6BBEC0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4498_4417"
          x1="52.372"
          y1="90.5254"
          x2="38.0982"
          y2="92.2508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7EE9EC" />
          <stop offset="1" stopColor="#6BBEC0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4498_4417"
          x1="36.9033"
          y1="75.0566"
          x2="22.6295"
          y2="76.7821"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7EE9EC" />
          <stop offset="1" stopColor="#6BBEC0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function CursorIcon(props) {
  return (
    <svg
      className={props.className}
      width="128"
      height="129"
      viewBox="0 0 128 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.9086 35.5921C30.0293 31.7817 33.4443 28.3667 37.2547 29.246L90.7412 41.5891C95.1493 42.6063 96.331 48.3275 92.6868 51.008L70.2794 67.4894C69.8488 67.8061 69.4687 68.1862 69.152 68.6168L52.6706 91.0242C49.9901 94.6684 44.2689 93.4867 43.2517 89.0786L30.9086 35.5921Z"
        fill="url(#paint0_linear_4498_4423)"
      />
      <g filter="url(#filter0_bi_4498_4423)">
        <path
          d="M57.8337 55.9221C62.0159 51.7399 68.7966 51.7399 72.9788 55.9221L92.4309 75.3742C96.613 79.5564 96.613 86.3371 92.4309 90.5192C88.2487 94.7014 81.468 94.7014 77.2859 90.5192L57.8337 71.0671C53.6516 66.8849 53.6516 60.1043 57.8337 55.9221Z"
          fill="#BCE4F1"
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <filter
          id="filter0_bi_4498_4423"
          x="46.6953"
          y="44.7856"
          width="56.8711"
          height="56.8701"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_4498_4423"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_4498_4423"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.4" dy="0.2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_4498_4423"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4498_4423"
          x1="53.8489"
          y1="9.13455"
          x2="16.5695"
          y2="59.1145"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7EE9EC" />
          <stop offset="1" stopColor="#6BBEC0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function MoneyBag(props) {
  return (
    <svg
      className={props.className}
      width="128"
      height="129"
      viewBox="0 0 128 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="20"
        y="32.3379"
        width="73.6744"
        height="64"
        rx="10"
        fill="url(#paint0_linear_4498_4428)"
      />
      <g filter="url(#filter0_bi_4498_4428)">
        <rect
          x="58.8828"
          y="54.3379"
          width="49.1163"
          height="20"
          rx="10"
          fill="#BCE4F1"
          fillOpacity="0.5"
        />
      </g>
      <ellipse cx="69.1161" cy="64.3379" rx="6.13953" ry="6" fill="white" />
      <defs>
        <filter
          id="filter0_bi_4498_4428"
          x="54.8828"
          y="50.3379"
          width="57.1172"
          height="28"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_4498_4428"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_4498_4428"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.2" dy="0.1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_4498_4428"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4498_4428"
          x1="89.4381"
          y1="32.3379"
          x2="23.243"
          y2="41.5492"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7EE9EC" />
          <stop offset="1" stopColor="#6BBEC0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function BoxOpen(props) {
  return (
    <svg
      className={props.className}
      width="128"
      height="129"
      viewBox="0 0 128 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 41.5694C28 36.8572 32.0524 33.1657 36.7442 33.6041L65.2658 36.2689C65.7542 36.3146 66.2458 36.3152 66.7343 36.2708L90.4456 34.1152C95.0685 33.6949 99.0774 37.2845 99.1684 41.9255L99.8898 78.7162C99.9559 82.0889 97.8993 85.1407 94.7484 86.3455L68.7058 96.303C66.9575 96.9714 65.0301 97.0057 63.2592 96.3999L33.4105 86.1885C30.1744 85.0814 28 82.0394 28 78.6192L28 41.5694Z"
        fill="url(#paint0_linear_4498_4433)"
      />
      <g filter="url(#filter0_bi_4498_4433)">
        <path
          d="M25.2252 32.3379L66 36.3379L51.0627 61.0293C50.2553 62.1925 49.0441 62.5802 47.833 62.1925L15.5361 53.2749C14.325 52.8872 13.5176 51.3363 14.325 49.7854L22.8029 33.8888C23.2067 32.7256 24.0141 32.3379 25.2252 32.3379Z"
          fill="#BCE4F1"
          fillOpacity="0.5"
        />
      </g>
      <g filter="url(#filter1_bi_4498_4433)">
        <path
          d="M112.049 51.8791L82.3398 60.2022C81.2257 60.5641 80.1117 60.2022 79.7403 59.1166L66 36.3379L103.507 32.3379C104.621 32.3379 105.364 32.6998 106.107 33.7854L113.905 48.6222C114.277 50.0697 113.534 51.5172 112.049 51.8791Z"
          fill="#BCE4F1"
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <filter
          id="filter0_bi_4498_4433"
          x="6"
          y="24.3379"
          width="68"
          height="46"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_4498_4433"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_4498_4433"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.4" dy="0.2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_4498_4433"
          />
        </filter>
        <filter
          id="filter1_bi_4498_4433"
          x="58"
          y="24.3379"
          width="64"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_4498_4433"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_4498_4433"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.4" dy="0.2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_4498_4433"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4498_4433"
          x1="95.86"
          y1="32.7871"
          x2="31.094"
          y2="41.5196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7EE9EC" />
          <stop offset="1" stopColor="#6BBEC0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function MailIcon(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21.3379" r="20" stroke={props.fill ?? "#549A9C"} />
      <path
        d="M30 13.8379H12C11.8011 13.8379 11.6103 13.9169 11.4697 14.0576C11.329 14.1982 11.25 14.389 11.25 14.5879V27.3379C11.25 27.7357 11.408 28.1172 11.6893 28.3986C11.9706 28.6799 12.3522 28.8379 12.75 28.8379H29.25C29.6478 28.8379 30.0294 28.6799 30.3107 28.3986C30.592 28.1172 30.75 27.7357 30.75 27.3379V14.5879C30.75 14.389 30.671 14.1982 30.5303 14.0576C30.3897 13.9169 30.1989 13.8379 30 13.8379ZM28.0716 15.3379L21 21.8207L13.9284 15.3379H28.0716ZM29.25 27.3379H12.75V16.2932L20.4928 23.391C20.6312 23.518 20.8122 23.5885 21 23.5885C21.1878 23.5885 21.3688 23.518 21.5072 23.391L29.25 16.2932V27.3379Z"
        fill={props.fill ?? "#549A9C"}
      />
    </svg>
  );
}

function FacebookIcon(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21.3379" r="20" stroke={props.fill ?? "#549A9C"} />
      <path
        d="M22.6185 22.6964H24.5233L25.2852 19.6449H22.6185V18.1192C22.6185 17.3339 22.6185 16.5934 24.1423 16.5934H25.2852V14.0302C25.037 13.9972 24.0989 13.9233 23.1083 13.9233C21.0401 13.9233 19.5709 15.1873 19.5709 17.5086V19.6449H17.2852V22.6964H19.5709V29.1809H22.6185V22.6964Z"
        fill={props.fill ?? "#549A9C"}
      />
    </svg>
  );
}

function XIcon(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21.3379" r="20" stroke={props.fill ?? "#549A9C"} />
      <path
        d="M23.3463 20.2376L28.51 13.8379H26.2052L22.264 18.7256L18.7675 13.8379H13.75L19.6045 22.0204L14.1025 28.8379H16.408L20.6867 23.5354L24.4825 28.8379H29.5L23.3463 20.2376ZM21.5612 22.4501L20.4775 20.9359L16.27 15.0581H18.0025L21.3985 19.7959L22.4808 21.3109L26.9943 27.6176H25.2618L21.5612 22.4501Z"
        fill={props.fill ?? "#549A9C"}
      />
    </svg>
  );
}

function InstagramIcon(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21.3379" r="20" stroke={props.fill ?? "#549A9C"} />
      <path
        d="M21.7495 13.9233C22.5827 13.9247 23.0049 13.9291 23.3697 13.94L23.5134 13.9447C23.6794 13.9506 23.8432 13.958 24.0406 13.9673C24.8284 14.0037 25.3658 14.1285 25.8377 14.312C26.3257 14.5004 26.7378 14.7549 27.1493 15.1669C27.5602 15.5789 27.8144 15.9928 28.0032 16.4802C28.1858 16.9521 28.3104 17.4908 28.3474 18.2796C28.3562 18.4773 28.3634 18.6412 28.3692 18.8075L28.3739 18.9513C28.3847 19.3166 28.3896 19.7394 28.3912 20.5736L28.3918 21.1264C28.3919 21.1939 28.3919 21.2636 28.3919 21.3355L28.3918 21.5446L28.3913 22.0974C28.3899 22.9316 28.3856 23.3543 28.3747 23.7196L28.3699 23.8635C28.3641 24.0297 28.3567 24.1936 28.3474 24.3913C28.311 25.1801 28.1858 25.7182 28.0032 26.1908C27.815 26.6793 27.5602 27.092 27.1493 27.504C26.7378 27.9154 26.3238 28.1699 25.8377 28.359C25.3658 28.5418 24.8284 28.6666 24.0406 28.7036C23.8432 28.7125 23.6794 28.7196 23.5134 28.7254L23.3697 28.7301C23.0049 28.7409 22.5827 28.7459 21.7495 28.7475L21.1975 28.7481C21.13 28.7481 21.0605 28.7481 20.9886 28.7481L20.7798 28.7481L20.2277 28.7476C19.3946 28.7462 18.9723 28.7418 18.6075 28.7309L18.4638 28.7262C18.2978 28.7203 18.1341 28.7129 17.9367 28.7036C17.1488 28.6672 16.6121 28.5418 16.1395 28.359C15.6521 28.1705 15.2394 27.9154 14.8279 27.504C14.4164 27.092 14.1629 26.6775 13.9741 26.1908C13.7909 25.7182 13.6669 25.1801 13.6298 24.3913C13.621 24.1936 13.6139 24.0297 13.6081 23.8635L13.6034 23.7196C13.5926 23.3543 13.5876 22.9316 13.586 22.0974L13.5859 20.5736C13.5873 19.7394 13.5917 19.3166 13.6026 18.9513L13.6073 18.8075C13.6132 18.6412 13.6206 18.4773 13.6298 18.2796C13.6662 17.4902 13.7909 16.9527 13.9741 16.4802C14.1622 15.9922 14.4164 15.5789 14.8279 15.1669C15.2394 14.7549 15.6528 14.501 16.1395 14.312C16.6115 14.1285 17.1482 14.0044 17.9367 13.9673C18.1341 13.9585 18.2978 13.9513 18.4638 13.9455L18.6075 13.9408C18.9723 13.93 19.3946 13.925 20.2277 13.9234L21.7495 13.9233ZM20.9886 17.6291C18.9432 17.6291 17.287 19.2892 17.287 21.3355C17.287 23.3835 18.945 25.0418 20.9886 25.0418C23.0341 25.0418 24.6902 23.3817 24.6902 21.3355C24.6902 19.2874 23.0322 17.6291 20.9886 17.6291ZM20.9886 19.1117C22.2153 19.1117 23.2096 20.1069 23.2096 21.3355C23.2096 22.5637 22.2156 23.5593 20.9886 23.5593C19.762 23.5593 18.7677 22.564 18.7677 21.3355C18.7677 20.1073 19.7616 19.1117 20.9886 19.1117ZM24.8753 16.5172C24.365 16.5172 23.9499 16.9323 23.9499 17.4432C23.9499 17.9541 24.3644 18.3698 24.8753 18.3698C25.3856 18.3698 25.8007 17.9548 25.8007 17.4432C25.8007 16.9323 25.3849 16.5166 24.8753 16.5172Z"
        fill={props.fill ?? "#549A9C"}
      />
    </svg>
  );
}

function LinkedInIcon(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21.3379" r="20" stroke={props.fill ?? "#549A9C"} />
      <g clipPath="url(#clip0_4498_4494)">
        <path
          d="M29.1267 29.4702L29.1308 29.4695V23.4962C29.1308 20.574 28.5017 18.323 25.0855 18.323C23.4432 18.323 22.3411 19.2242 21.8912 20.0786H21.8437V18.5958H18.6046V29.4695H21.9774V24.0853C21.9774 22.6676 22.2461 21.2968 24.0017 21.2968C25.7316 21.2968 25.7574 22.9146 25.7574 24.1762V29.4702H29.1267ZM13.1125 18.5965H16.4893V29.4702H13.1125V18.5965ZM14.7996 13.1831C13.7199 13.1831 12.8438 14.0592 12.8438 15.1389C12.8438 16.2186 13.7199 17.113 14.7996 17.113C15.8793 17.113 16.7554 16.2186 16.7554 15.1389C16.755 14.6203 16.5488 14.1231 16.1821 13.7563C15.8154 13.3896 15.3182 13.1835 14.7996 13.1831Z"
          fill={props.fill ?? "#549A9C"}
        />
      </g>
      <defs>
        <clipPath id="clip0_4498_4494">
          <rect
            width="16.2871"
            height="16.2871"
            fill="white"
            transform="translate(12.8438 13.1831)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

const ArrowUpRight = (props) => {
  return (
    <svg
      className={props.className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.082 6V15.75C19.082 15.9489 19.0029 16.1397 18.8623 16.2803C18.7216 16.421 18.5309 16.5 18.332 16.5C18.133 16.5 17.9423 16.421 17.8016 16.2803C17.661 16.1397 17.582 15.9489 17.582 15.75V7.81031L6.86259 18.5306C6.72185 18.6714 6.53098 18.7504 6.33196 18.7504C6.13294 18.7504 5.94207 18.6714 5.80133 18.5306C5.6606 18.3899 5.58154 18.199 5.58154 18C5.58154 17.801 5.6606 17.6101 5.80133 17.4694L16.5216 6.75H8.58196C8.38305 6.75 8.19228 6.67098 8.05163 6.53033C7.91098 6.38968 7.83196 6.19891 7.83196 6C7.83196 5.80109 7.91098 5.61032 8.05163 5.46967C8.19228 5.32902 8.38305 5.25 8.58196 5.25H18.332C18.5309 5.25 18.7216 5.32902 18.8623 5.46967C19.0029 5.61032 19.082 5.80109 19.082 6Z"
        fill={props.fill ?? "white"}
      />
    </svg>
  );
};

const ArrowRight = (props) => {
  return (
    <svg
      className={props.className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.1127 12.5306L14.3627 19.2806C14.2219 19.4214 14.0311 19.5004 13.832 19.5004C13.633 19.5004 13.4421 19.4214 13.3014 19.2806C13.1607 19.1399 13.0816 18.949 13.0816 18.75C13.0816 18.551 13.1607 18.3601 13.3014 18.2194L18.7717 12.75H4.08203C3.88312 12.75 3.69235 12.671 3.5517 12.5303C3.41105 12.3897 3.33203 12.1989 3.33203 12C3.33203 11.8011 3.41105 11.6103 3.5517 11.4697C3.69235 11.329 3.88312 11.25 4.08203 11.25H18.7717L13.3014 5.78063C13.1607 5.6399 13.0816 5.44903 13.0816 5.25001C13.0816 5.05098 13.1607 4.86011 13.3014 4.71938C13.4421 4.57865 13.633 4.49959 13.832 4.49959C14.0311 4.49959 14.2219 4.57865 14.3627 4.71938L21.1127 11.4694C21.1824 11.539 21.2377 11.6218 21.2755 11.7128C21.3132 11.8038 21.3326 11.9014 21.3326 12C21.3326 12.0986 21.3132 12.1962 21.2755 12.2872C21.2377 12.3783 21.1824 12.461 21.1127 12.5306Z"
        fill={props.fill ?? "#549A9C"}
      />
    </svg>
  );
};

const HoverBackgroundOld = (props) => {
  return (
    <svg
      className={props.className}
      width="778"
      height="596"
      viewBox="0 0 778 596"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_109_735)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M379.342 216.302C431.633 165.21 490.867 143.806 523.159 168.338C550.835 189.362 551.311 238.498 528.724 292.453C598.579 276.669 658.831 289.032 673.651 326.158C691.873 371.809 634.501 437.613 545.507 473.136C456.513 508.659 369.598 500.448 351.376 454.797C351.353 454.74 351.331 454.684 351.308 454.627C336.612 455.629 323.559 452.479 313.251 444.648C313.064 444.507 312.879 444.364 312.695 444.219C307.095 446.372 301.306 447.5 295.382 447.5C289.374 447.5 283.506 446.34 277.832 444.128C277.609 444.303 277.385 444.477 277.159 444.648C266.992 452.372 254.154 455.542 239.703 454.666L239.65 454.797C221.428 500.448 134.513 508.659 45.5192 473.136C-43.4745 437.613 -100.846 371.809 -82.6243 326.158C-67.8532 289.152 -7.94312 276.749 61.6223 292.3C39.0999 238.405 39.6017 189.342 67.2511 168.338C99.6052 143.759 159.004 165.292 211.369 216.596C223.524 148.985 256.548 100.5 295.382 100.5C334.159 100.5 367.144 148.844 379.342 216.302Z"
          fill="url(#paint0_linear_109_735)"
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_109_735"
          x="-186"
          y="0.5"
          width="963.026"
          height="594.717"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="50"
            result="effect1_foregroundBlur_109_735"
          />
        </filter>
        <linearGradient
          id="paint0_linear_109_735"
          x1="295.513"
          y1="495.217"
          x2="295.513"
          y2="100.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55BFD7" />
          <stop stopColor="#63D3D3" stopOpacity="0.8" />
          <stop offset="0.602767" stopColor="#73EBCF" stopOpacity="0.4" />
          <stop offset="1" stopColor="#BBFDFF" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const HoverBackground = (props) => {
  return (
    <svg width="800" height="600" viewBox="-150 0 1000 600" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: "scale(1.3) translateX(12%)" }}>
      <g filter="url(#filter0_f_109_735)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M379.342 216.302C431.633 165.21 490.867 143.806 523.159 168.338C550.835 189.362 551.311 238.498 528.724 292.453C598.579 276.669 658.831 289.032 673.651 326.158C691.873 371.809 634.501 437.613 545.507 473.136C456.513 508.659 369.598 500.448 351.376 454.797C351.353 454.74 351.331 454.684 351.308 454.627C336.612 455.629 323.559 452.479 313.251 444.648C313.064 444.507 312.879 444.364 312.695 444.219C307.095 446.372 301.306 447.5 295.382 447.5C289.374 447.5 283.506 446.34 277.832 444.128C277.609 444.303 277.385 444.477 277.159 444.648C266.992 452.372 254.154 455.542 239.703 454.666L239.65 454.797C221.428 500.448 134.513 508.659 45.5192 473.136C-43.4745 437.613 -100.846 371.809 -82.6243 326.158C-67.8532 289.152 -7.94312 276.749 61.6223 292.3C39.0999 238.405 39.6017 189.342 67.2511 168.338C99.6052 143.759 159.004 165.292 211.369 216.596C223.524 148.985 256.548 100.5 295.382 100.5C334.159 100.5 367.144 148.844 379.342 216.302Z" fill="url(#paint0_linear_109_735)" fill-opacity="0.5"></path>
      </g>
      <defs>
        <filter id="filter0_f_109_735" x="-250" y="0.5" width="1200" height="600" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_109_735"></feGaussianBlur>
        </filter>
        <linearGradient id="paint0_linear_109_735" x1="295.513" y1="495.217" x2="295.513" y2="100.5" gradientUnits="userSpaceOnUse">
          <stop stop-color="#55BFD7"></stop>
          <stop stop-color="#63D3D3" stop-opacity="0.8"></stop>
          <stop offset="0.602767" stop-color="#73EBCF" stop-opacity="0.4"></stop>
          <stop offset="1" stop-color="#BBFDFF" stop-opacity="0.1"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

const ArrowUp = (props) => {
  return (
    <svg
      className={props.className}
      width="15"
      height="8"
      viewBox="0 0 15 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49997 -1.78836e-07C7.58952 -9.02932e-05 7.6782 0.0171197 7.76092 0.0506409C7.84365 0.0841626 7.91878 0.133334 7.98201 0.195332L14.8002 6.86196C15.0666 7.12246 15.0666 7.54429 14.8002 7.80463C14.5338 8.06496 14.1023 8.06512 13.8361 7.80463L7.49997 1.60932L1.16384 7.80462C0.897422 8.06512 0.466001 8.06512 0.199751 7.80462C-0.0664987 7.54413 -0.0666684 7.1223 0.199751 6.86196L7.01792 0.195332C7.08116 0.133333 7.15629 0.0841625 7.23902 0.0506409C7.32174 0.0171197 7.41042 -9.03089e-05 7.49997 -1.78836e-07Z"
        fill="#3D3D3D"
      />
    </svg>
  );
};

export {
  // New Landing Page Exports - Start
  CreatorCLogo,
  SmileyWink,
  RocketLaunchIcon,
  SparklesIcon,
  TickIcon,
  FlyingMoney,
  CursorIcon,
  MoneyBag,
  BoxOpen,
  MailIcon,
  FacebookIcon,
  XIcon,
  InstagramIcon,
  LinkedInIcon,
  ArrowUpRight,
  ArrowRight,
  HoverBackground,
  ArrowUp,
  // New Landing Page Exports - End
};
